/* Mobile menu for sections/bs-header.liquid. Below 980px the button toggles a single flat list (nav links + Shop)
   layered over the page: focus moves in, Tab is trapped inside it, Escape and a link tap close it, and the body
   can't scroll behind it. Re-bound on shopify:section:load so the theme editor keeps working. */
(function () {
  function focusable(root) {
    return [].slice.call(root.querySelectorAll('a[href], button:not([disabled])')).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
    });
  }

  function bind(toggle) {
    if (toggle.bsMenuBound) return;
    toggle.bsMenuBound = true;

    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    var closeBtn = panel.querySelector('[data-bs-menu-close]');
    var lastFocus = null;

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { close(); return; }
      if (e.key !== 'Tab') return;
      var items = focusable(panel);
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      lastFocus = document.activeElement;
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('bs-menu-open');
      document.addEventListener('keydown', onKeydown, true);
      (closeBtn || focusable(panel)[0] || panel).focus();
    }

    function close() {
      if (panel.hidden) return;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('bs-menu-open');
      document.removeEventListener('keydown', onKeydown, true);
      (lastFocus || toggle).focus();
    }

    toggle.addEventListener('click', function () { if (panel.hidden) open(); else close(); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    [].slice.call(panel.querySelectorAll('a')).forEach(function (a) { a.addEventListener('click', close); });
    addEventListener('resize', function () { if (!panel.hidden && innerWidth >= 980 && !panel.classList.contains('bs-menu-compact')) close(); });
  }

  function scan(root) {
    [].slice.call((root || document).querySelectorAll('[data-bs-menu-toggle]')).forEach(bind);
  }

  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  /* desktop dropdowns: click toggles (touch and keyboard), hover opens by CSS; outside click and Escape close */
  function bindGroups(root) {
    [].slice.call((root || document).querySelectorAll('[data-bs-nav-group]')).forEach(function (g) {
      if (g.bsBound) return; g.bsBound = true;
      var btn = g.querySelector('button');
      function set(open) { g.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      btn.addEventListener('click', function (e) { e.stopPropagation(); set(!g.classList.contains('is-open')); });
      document.addEventListener('click', function (e) { if (!g.contains(e.target)) set(false); });
      g.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); btn.focus(); } });
      g.addEventListener('focusout', function (e) { if (!g.contains(e.relatedTarget)) set(false); });
    });
  }
  bindGroups();
  document.addEventListener('shopify:section:load', function (e) { bindGroups(e.target); });
})();
